const chargerEventTypes = ['TIMED_CHARGE', 'AD_HOC_CHARGE', 'PREDICTED', 'COMPLETED', 'RESERVATION'] as const
export type ChargerEventType = (typeof chargerEventTypes)[number]
export function isChargerEventType(eventType?: string): eventType is ChargerEventType {
  return chargerEventTypes.includes(eventType as ChargerEventType)
}

export const recurringEventTypes = [
  'DailyRepeating',
  'WeeklyRepeating',
  'WeekdaysRepeating',
  'CustomRepeating'
] as const

export type RecurringEventType = (typeof recurringEventTypes)[number]
export type RecurrenceEventType = 'SingleEvent' | RecurringEventType
export type RecurringDay = 'MO' | 'TU' | 'WE' | 'TH' | 'FR' | 'SA' | 'SU'
